import {useEffect} from 'react';
import {useSearchParams} from 'react-router-dom';
import {useExchanges} from 'components/exchangeSelect/ExchangeSelect';

const LAST_EXCHANGE_KEY = 'news-sources-exchange';

const readLastExchange = () => {
  try {
    return localStorage.getItem(LAST_EXCHANGE_KEY);
  } catch {
    return null;
  }
};

const rememberExchange = code => {
  try {
    localStorage.setItem(LAST_EXCHANGE_KEY, code);
  } catch {
    // Private windows can refuse storage; the URL still carries the choice.
  }
};

// The exchange the pipeline tabs are scoped to. It lives in the URL
// (?exchange=BRVM) and the last choice is shared across the tabs and
// remembered for the next visit.
export const useNewsExchange = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const {exchanges, loading} = useExchanges();

  const code = searchParams.get('exchange') || readLastExchange();
  const exchange = exchanges.find(item => item.code === code);

  useEffect(() => {
    if (!code) return;
    rememberExchange(code);
    if (!searchParams.get('exchange')) {
      setSearchParams({exchange: code}, {replace: true});
    }
  }, [code, searchParams, setSearchParams]);

  const selectExchange = id => {
    const next = exchanges.find(item => item.id === id);
    if (next?.code) setSearchParams({exchange: next.code});
  };

  // `waiting`: an exchange is chosen but the list hasn't arrived to resolve it.
  return {
    exchange,
    exchangeId: exchange?.id,
    selectExchange,
    waiting: Boolean(code) && loading,
  };
};
